import $http from '../../../axios-instance';
import Swal from 'sweetalert2';


export async function getMatrix({state, commit}) {
    commit('dashboard/load', true, {root: true});

    let params = {
        params: state.filters
    };

    await $http.get('matriz-ram', params)
        .then((response) => {
            commit('setMatrix', response.data.data.consequences_company);
            commit('setIncrementalProbabilites', response.data.data.incremental_probabilities);
            commit('dashboard/load', false, {root: true});
        }).catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function store({state, commit, dispatch}) {
    commit('dashboard/load', true, {root: true});

    commit('setCompanyIdConsequence', state.filters.company_id);

    await $http.post('consecuencias', state.consequence)
        .then(async (response) => {
            await dispatch('getMatrix');
            commit('setModalShow', false);
            commit('dashboard/load', false, {root: true});

            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: 'Consecuencia y severidades creadas correctamente',
                showConfirmButton: true,
                timer: 3000
            });

        }).catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function update({state, commit, dispatch}) {
    commit('dashboard/load', true, {root: true});

    commit('setCompanyIdConsequence', state.filters.company_id);

    await $http.put('consecuencias/' + state.consequence.id, state.consequence)
        .then(async (response) => {
            await dispatch('getMatrix');
            commit('setModalShow', false);
            commit('dashboard/load', false, {root: true});

            await Swal.fire({
                position: 'center',
                icon: 'success',
                title: 'Muy bien!',
                text: 'Consecuencia y severidades actualizadas correctamente',
                showConfirmButton: true,
                timer: 3000
            });

        }).catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function getConsequence({state, commit}, id) {
    commit('dashboard/load', true, {root: true});

    await $http.get('consecuencias/' + id + '/' + state.filters.company_id)
        .then((response) => {

            commit('setConsequence', response.data.data);
            commit('dashboard/load', false, {root: true});
        }).catch((error) => {
            commit('dashboard/load', false, {root: true});
            Swal.fire({
                position: 'center',
                icon: 'error',
                title: error.message + '<br> ' + error.errors,
                showConfirmButton: true,
                timer: 5000
            });
        });
}

export async function getCompanies({commit, state}, filter) {
    if (!state.loading_companies && filter && filter.length > 2) {
        commit('setLoadingCompanies', true);

        let parameters = {
            params: {
                nombre: filter
            }
        };

        await $http.get('/empresas/lista', parameters)
            .then((response) => {
                commit('setCompanies', response.data.data);
                commit('setLoadingCompanies', false);
            })
            .catch(() => {
                console.warn('No se encontraron empresas con el nombre especificado');
                commit('setLoadingCompanies', false);
            });
    }
}

export async function destroy({commit, state, dispatch}, id) {

    await Swal.fire({
        title: 'Cambiar estado',
        text: '¿Está seguro de eliminar la consecuencia?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'Cancelar',
        confirmButtonText: 'Si, eliminar'
    }).then(async (result) => {
        if (result.value) {

            commit('dashboard/load', true, {root: true});

            await $http.delete(`consecuencias/${id}/${state.filters.company_id}`)
                .then(async (response) => {
                    await dispatch('getMatrix');
                    commit('dashboard/load', false, {root: true});

                    await Swal.fire({
                        position: 'center',
                        icon: 'success',
                        title: 'Muy bien!',
                        text: response.data.message,
                        showConfirmButton: true,
                        timer: 5000
                    });

                }).catch((error) => {
                    commit('dashboard/load', false, {root: true});
                    Swal.fire({
                        position: 'center',
                        icon: 'error',
                        title: error.message + '<br> ' + error.errors,
                        showConfirmButton: true,
                        timer: 5000
                    });
                });
        }
    });
}

